import { createAction } from '@reduxjs/toolkit';
import type { RawCatalogAPIData } from 'types/catalog_types';

const getAllShallow = {
  pending: createAction('catalogs/getAllShallow/pending'),
  fulfilled: createAction<RawCatalogAPIData[]>('catalogs/getAllShallow/fulfilled'),
  rejected: createAction('catalogs/getAllShallow/rejected'),
};

const getAllDeep = {
  pending: createAction('catalogs/getAllDeep/pending'),
  fulfilled: createAction<RawCatalogAPIData[]>('catalogs/getAllDeep/fulfilled'),
  rejected: createAction('catalogs/getAllDeep/rejected'),
};

export default { getAllShallow, getAllDeep };
